import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { cross } from '../utils/icons';

const easer = 'cubic-bezier(0.4, 0, 0.2, 1)';
const containerWidth = '20rem';
const containerHeight = '20rem';
const headerHeight = '4.375rem';
const animationStepTiming = '0.12s';

const borderRadiusMorph = keyframes`
  0% {
    border-radius: 50%;
  }

  50% {
    border-radius: 20px;
  }

  100% {
    border-radius: 20px 20px 0 0;
  }
`;

const borderRadiusMorphReverse = keyframes`
  0% {
    border-radius: 20px 20px 0 0;
  }

  50% {
    border-radius: 20px;
  }

  100% {
    border-radius: 50%;
  }
`;

const Wrapper = styled.div`
  position: fixed;
  bottom: 1.7rem;
  left: 5rem;
  height: ${headerHeight};
  width: ${headerHeight};
  transition: all ${animationStepTiming} ${easer},
    width ${animationStepTiming} ${easer} ${animationStepTiming},
    height ${animationStepTiming} ${easer} 0s;
  border-radius: 50%;
  z-index: 100;

  ${props =>
    props.expanded &&
    css`
      border-radius: 20px;
      height: ${containerHeight};
      width: ${containerWidth};
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);
      background-color: #f5f6f6;
      transition: all ${animationStepTiming} ${easer},
        width ${animationStepTiming} ${easer},
        height ${animationStepTiming} ${easer} ${animationStepTiming};
    `};

  @media all and (max-width: 64rem) {
    left: 1.5rem;
  }

  @media all and (max-width: 43.75rem) {
    ${props =>
      props.expanded &&
      css`
        width: calc(100vw - 3rem);
      `};
  }
`;

const Button = styled.a`
  background-color: ${props => props.theme.tertiary};
  color: #fff;
  display: flex;
  width: 100%;
  height: ${headerHeight};
  border-radius: 50%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  position: absolute;
  left: 0;
  top: 0;
  user-select: none;
  z-index: 4;

  svg {
    width: 21px;
    height: 17px;
    margin-bottom: 1px;
  }

  > * {
    transition: opacity 0.08s ${easer} ${animationStepTiming};
  }

  ${props =>
    props.expanded &&
    css`
      border-radius: 20px 20px 0 0;
      animation: ${borderRadiusMorph} 0.24s ${easer};
      cursor: default;

      > * {
        opacity: 0;
        transition: opacity 0.08s ${easer} 0s;
      }
    `};

  ${props =>
    !props.initial &&
    !props.expanded &&
    css`
      animation: ${borderRadiusMorphReverse} 0.24s ${easer};
    `};
`;

const Box = styled.div`
  position: absolute;
  left: 0;
  top: ${headerHeight};
  bottom: 0;
  right: 0;
  overflow-y: auto;
  opacity: 0;
  transform: translateY(100%);
  transition: transform ${animationStepTiming} ${easer},
    opacity ${animationStepTiming};
  padding: 2.4375rem;
  z-index: 3;
  -webkit-overflow-scrolling: touch;

  ${props =>
    props.expanded &&
    css`
      opacity: 1;
      transform: translateY(0px);
      transition: transform 0.38s ${easer} ${animationStepTiming}, opacity 0s;
    `};
`;

const Header = styled.div`
  color: #fff;
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  left: 2.4375rem;
  right: 2.4375rem;
  position: absolute;
  top: 0.85rem;
  display: flex;
  opacity: 0;
  transition: opacity 0.08s ${easer} 0s;
  justify-content: space-between;
  align-items: center;
  z-index: 3;

  ${props =>
    props.expanded &&
    css`
      opacity: 1;
      transition: opacity 0.08s ${easer} ${animationStepTiming};
      z-index: 4;
    `};
`;

const Close = styled.a`
  display: block;
  cursor: pointer;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -1rem;

  svg {
    width: 0.9rem;
    height: 0.8rem;

    g {
      stroke: #fff;
    }
  }
`;

class ActionExpander extends Component {
  state = {
    expanded: false,
    initial: true
  };

  render() {
    const { icon, label, children } = this.props;
    const { expanded, initial } = this.state;

    return (
      <Wrapper expanded={expanded}>
        <Button
          initial={initial}
          expanded={expanded}
          href="#"
          onClick={e => {
            e.preventDefault();
            if (!expanded) this.setState({ expanded: true, initial: false });
          }}
        >
          {icon}
          <span>{label}</span>
        </Button>
        <Box expanded={expanded}>{children}</Box>
        <Header expanded={expanded}>
          <span>Mine notater</span>
          <Close
            href="#"
            onClick={e => {
              e.preventDefault();
              this.setState({ expanded: false });
            }}
          >
            {cross}
          </Close>
        </Header>
      </Wrapper>
    );
  }
}

ActionExpander.propTypes = {
  icon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired
};

export default ActionExpander;



// WEBPACK FOOTER //
// ./src/components/ActionExpander.js